import React, { useContext, useEffect, useState } from "react";
import Logo from "../../Assets/logo.png";
import { AppContext } from "../../Context/AppContext";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";

function OtpVerify() {
  const location = useLocation();
  const navigate = useNavigate();
  const { resetReq, authLoading, verifyOtp, deleteCookieData } =
    useContext(AppContext);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    deleteCurrentCookie();
  }, []);

  const deleteCurrentCookie = async () => {
    await deleteCookieData({
      onLogoutSuccess: () => {
        navigate(location.pathname, { replace: false });
      },
    });
  };

  const email = sessionStorage.getItem("email");

  const resendEmail = async () => {
    if (!email) {
      toast.error("Email address is missing!");
      return;
    }
    await resetReq(
      { email },
      {
        onSuccess: (res) => {
          toast.success("Otp resent successfully!");
          sessionStorage.setItem("email", res.data.email);
          sessionStorage.setItem("id", res.data._id);
        },
        onFailed: (err) => {
          const errMsg = err.message ?? "Something went wrong!";
          toast.error(errMsg);
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const id = sessionStorage.getItem("id");
    if (otp.length !== 6) {
      alert("Please enter a 6-digit OTP");
      return;
    }

    if (!id || id.length == 0) {
      toast.error("Something went worng, Please verify your email address!");
      navigate("/reset-password");
      return;
    }

    const payload = {
      OTP: otp,
      id,
    };

    await verifyOtp(payload, {
      onSuccess: (res) => {
        toast.success("Otp verified successfully!");
        sessionStorage.removeItem("email");
        navigate("/new-password");
      },
      onFailed: (err) => {
        const errMsg = err.message ?? "Something went wrong!";
        toast.error(errMsg);
      },
    });
  };

  return (
    <>
      <Toaster />
      <div className="otp-container">
        <div className="otp-form">
          <form onSubmit={handleSubmit}>
            <div className="logo-container">
              <img src={Logo} alt="Logo" className="logo-img" />
            </div>
            <h2 className="otp-title">Verify OTP</h2>
            <p className="otp-subtitle">
              Enter the 6-digit code sent to your email {email ?? ""}
            </p>
            <input
              type="text"
              maxLength={6}
              className="otp-input"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
            />
            <button type="submit" className="otp-btn" disabled={authLoading}>
              {authLoading ? <PulseLoader color="#fff" size={10} /> : "Verify"}
            </button>
          </form>
          <br />

          <button
            type="button"
            className="resend_otp"
            disabled={authLoading}
            onClick={resendEmail}
          >
            Resed OTP
          </button>
        </div>
      </div>
    </>
  );
}

export default OtpVerify;
